import React from "react";
import { FlyoutContent } from '@amzn/stencil-react-components/flyout';
import { Button, ButtonVariant } from "@amzn/stencil-react-components/button";
import { Col } from "@amzn/stencil-react-components/layout";
import { Link } from '@amzn/stencil-react-components/link';
import { IconExternalLink } from "@amzn/stencil-react-components/icons";
import { Table } from '@amzn/stencil-react-components/table';
import { AttributeRule } from "src/entity/entities";
import { Spinner } from '@amzn/stencil-react-components/spinner';
import { CommonConstants } from "src/constant/constants";

const STRINGS_DISPLAYED = {
  available_data_attributes: "Available data attributes",
  attribute_name: "Attribute name",
  description: "Description",
  view_available_attributes: "View available data attributes in Segmentation Service UI.",
  external_link_icon_title: "Opens in a new window",
}

type props = {
  close: () => void;
  dataAttributes: AttributeRule[],
}

/**
 * Renders flyout for showing available data attributes.
 */
export const AvailableDataAttributesFlyoutContent = ({ close, dataAttributes }: props) => {

  return <FlyoutContent
    titleText={STRINGS_DISPLAYED.available_data_attributes}
    onCloseButtonClick={close}
    buttons={[
      <Button onClick={close} variant={ButtonVariant.Secondary}>
        Done
      </Button>
    ]}>
      <Col gridGap={"16px"} width={"35vw"} overflow={"hidden"} padding={{right: "20px"}}>
        {(dataAttributes)
          ? <>
              <Table 
                columns={[
                  {
                    accessor: "attributeName",
                    header: STRINGS_DISPLAYED.attribute_name,
                  },
                  {
                    accessor: "description",
                    header: STRINGS_DISPLAYED.description,
                  },
                ]}
                data={dataAttributes}
              />

              <Link
                target={"_blank"}
                href={CommonConstants.SSUI_LINK}
                icon={<IconExternalLink 
                  title={STRINGS_DISPLAYED.external_link_icon_title} 
                />}
              >
                {STRINGS_DISPLAYED.view_available_attributes}
              </Link>
            </>
          : <Spinner />}
      </Col>
    </FlyoutContent>
}

